import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { userContext } from "../context/UserContext";

const Footer = () => {
  const { user } = useContext(userContext);
  return (
    <footer className="footer py-30">
      <img
        src="assets/images/bg/body-bottom-bg.png"
        alt="BG"
        className="body-bottom-bg"
      />
      <div className="container container-lg px-lg-36 px-12">
        <div className="footer-item-wrapper d-flex align-items-start flex-wrap justify-content-evenly">
          <div className="footer-item m-5">
            <div className="footer-item__logo">
              <Link to="/">
                {" "}
                <img src="assets/images/logo/logo.png" alt="" />
              </Link>
            </div>

            <div className="flex-align gap-16 mb-16">
              <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                <i className="ph-fill ph-map-pin" />
              </span>
              <span className="text-md text-gray-900 text-15">
                Shop Nom. 7, AL Zenia Complex 2,
                <br />
                Ground Floor, Near McDonald,
                <br />
                ibn Khaldoun street,
                <br />
                Hawally, Kuwait.
              </span>
            </div>
            <div className="flex-align gap-16 mb-16">
              <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                <i className="ph-fill ph-phone-call" />
              </span>
              <div className="flex-align gap-16 flex-wrap">
                <Link
                  to="/tel:+9561234578"
                  className="text-md text-gray-900 hover-text-main-600 text-15"
                >
                  +956 1234578
                </Link>
              </div>
            </div>
            <div className="flex-align gap-16 mb-16">
              <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                <i className="ph-fill ph-envelope" />
              </span>
              <Link
                to="/mailto:support24@marketpro.com"
                className="text-md text-gray-900 hover-text-main-600 text-15"
              >
                info@supplynest.com
              </Link>
            </div>
          </div>
          <div className="footer-item fs-6">
            <h6 className="footer-item__title">Information</h6>
            <ul className="footer-menu text-15">
              <li className="mb-16">
                <a href="/" className="text-gray-600 hover-text-main-600">
                  Home
                </a>
              </li>
              <li className="mb-16">
                <a href="/shop" className="text-gray-600 hover-text-main-600">
                  Category
                </a>
              </li>
              <li className="mb-16">
                <a href="/about" className="text-gray-600 hover-text-main-600">
                  About Us
                </a>
              </li>
              <li className="mb-16">
                <a href="/#" className="text-gray-600 hover-text-main-600">
                  Privacy Policy
                </a>
              </li>
              <li className="mb-16">
                <a href="/#" className="text-gray-600 hover-text-main-600">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-item fs-6">
            <h6 className="footer-item__title">Daily Groceries</h6>
            <ul className="footer-menu text-15">
              <li className="mb-16">
                <a href="/shop" className="text-gray-600 hover-text-main-600">
                  Ovens
                </a>
              </li>
              <li className="mb-16">
                <a href="/shop" className="text-gray-600 hover-text-main-600">
                  Griddle
                </a>
              </li>
              <li className="mb-16">
                <a href="/shop" className="text-gray-600 hover-text-main-600">
                  Freezers
                </a>
              </li>
              <li className="mb-16">
                <a href="/shop" className="text-gray-600 hover-text-main-600">
                  Servingware
                </a>
              </li>
              <li className="mb-16">
                <a href="/shop" className="text-gray-600 hover-text-main-600">
                  Food Processor
                </a>
              </li>
              <li className="mb-16">
                <a href="/shop" className="text-gray-600 hover-text-main-600">
                  Cooking Equipment
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-item fs-6">
            <h6 className="footer-item__title">My Account</h6>
            <ul className="footer-menu text-15">
              <li className="mb-16">
                <a
                  href={user?.name == "guest" ? "/login" : "/dashboard"}
                  className="text-gray-600 hover-text-main-600"
                >
                  My Account
                </a>
              </li>
              <li className="mb-16">
                <a
                  href={user?.name == "guest" ? "/login" : "/cart"}
                  className="text-gray-600 hover-text-main-600"
                >
                  Shoping Cart
                </a>
              </li>
              <li className="mb-16">
                <a
                  href={user?.name == "guest" ? "/login" : "/my-order"}
                  className="text-gray-600 hover-text-main-600"
                >
                  Order History
                </a>
              </li>
              {/* <li className="">
                <a to="/shop" className="text-gray-600 hover-text-main-600">
                  Wishlist
                </a>
              </li> */}
            </ul>
          </div>

          <div className="d-flex flex-column fs-6">
            <div className="footer-item mb-22">
              <h6 className="footer-item__title">Customer Support</h6>
              <ul className="footer-menu text-15">
                <li className="mb-16">
                  <a
                    href="/contact"
                    className="text-gray-600 hover-text-main-600"
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-item">
              <h6 className="">Follow Us</h6>

              <ul className="flex-align gap-16 mb-16">
                <li>
                  <Link
                      to="/https://www.facebook.com"
                      className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                  >
                    <i className="ph-fill ph-facebook-logo"/>
                  </Link>
                </li>
                <li>
                  <Link
                      to="/https://www.twitter.com"
                      className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                  >
                    <i className="ph-fill ph-twitter-logo"/>
                  </Link>
                </li>
                <li>
                  <Link
                      to="/https://www.linkedin.com"
                      className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                  >
                    <i className="ph-fill ph-instagram-logo"/>
                  </Link>
                </li>
                <li>
                  <Link
                      to="/https://www.pinterest.com"
                      className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                  >
                    <i className="ph-fill ph-linkedin-logo"/>
                  </Link>
                </li>
              </ul>

            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
